import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { AuthPasswordChangeRequest } from '../../requests/platform/auth-password-change.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root'
})
export class AuthPasswordChangeService extends CommonService {
  private readonly baseUrl = environment.urlApiPlatform + 'AuthPasswordChange/';

  constructor(private http: HttpClient) {
    super();
  }

  /** POST /AuthPasswordChange */
  public ChangePassword(request: AuthPasswordChangeRequest): Observable<ReturnStruct> {
    const url = this.baseUrl;
    return this.http
      .post<ReturnStruct>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
